import script from "./EditCustomerPaymentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCustomerPaymentDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditCustomerPaymentDialog.vue?vue&type=style&index=0&id=6467197f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6467197f"]])

export default __exports__